import { notifications } from '@mantine/notifications'

export const shareArticle = (title: string): void => {
  const url = globalThis.location.href

  const copyFallback = () => {
    navigator.clipboard
      .writeText(url)
      .then(() =>
        notifications.show({
          message: 'Link copied to clipboard',
          color: 'blue'
        })
      )
      .catch(() => {
        // noop
      })
  }

  if (navigator.share) {
    navigator.share({ title, url }).catch(copyFallback)
  } else {
    copyFallback()
  }
}
